import { RelativeTooltip } from './relative-tooltip';

export default RelativeTooltip;
